/**
 *
 * @param {*} order Coming from backend api
 * opens juspay payments link
 */
export const initiateJuspay = (order) => {
  // getting web as weblink to redirect coming from backend
  if (order?.web) window.location.href = order?.web;
};
